import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../../components/table/TableOps';
import AddCliente from './addCliente';

class GrupoClientes extends TableComponent {

  componentDidMount() {
		const { params } = this.props.match;
		// console.log(this.props)
		this.tableConfig(
			{ dataUrl: `cliente-grupo/${this.props.match.params.id}/filter`, deleteUrl: 'cliente-grupo/delete', deleteField: 'cliente_rsocial', modUrl: ``, query: { id_cliente: params.id } },
			TableOp.Table('Grupos', [
				{ label: 'Clave', id: 'cliente' },
				{ label: 'Nombre', id: 'cliente_rsocial' },
			], [
				{ id: 'delete', icon: 'delete' },
			])
		);
		this.table();
	}

  render() {
    return (
      <div>
        <AddCliente onSave={() => { this.table() }} />
        <this.TableRender />
      </div>
    )
  }
}


export default withRouter(GrupoClientes);
